// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b40731bf","455":"019dc635"}[chunkId] + ".chunk.js";
};